/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum IsoDayOfWeekType {
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
    Saturday = 'Saturday',
    Sunday = 'Sunday'
}

export function IsoDayOfWeekTypeFromJSON(json: any): IsoDayOfWeekType {
    return IsoDayOfWeekTypeFromJSONTyped(json, false);
}

export function IsoDayOfWeekTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): IsoDayOfWeekType {
    return json as IsoDayOfWeekType;
}

export function IsoDayOfWeekTypeToJSON(value?: IsoDayOfWeekType | null): any {
    return value as any;
}

